module.exports = __webpack_public_path__ + "img/537387_75BBB9_152E5B_0E85E8-256px.f603990c.png";